import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  ProductCategory,
  ProductSubcategory,
  RequestResponse,
} from '@/types';
import type {
  ProductCategoryCreatePayload,
  ProductCategoryUpdatePayload,
  ProductSubcategoryUpdatePayload,
} from './payload';

export const createProductCategory = async (
  payload: ProductCategoryCreatePayload
) => {
  const body: ProductCategoryCreatePayload = {};

  if (payload.categoryId) {
    body.categoryId = payload.categoryId;
  }

  if (payload.name?.trim()) {
    body.name = payload.name.trim();
  }

  if (payload.subcategories?.length) {
    body.subcategories = payload.subcategories;
  }

  const response = await axiosInstance.post<RequestResponse<ProductCategory>>(
    endpoints.categories,
    body
  );
  return response.data;
};

export const updateProductCategory = async ({
  id,
  ...payload
}: ProductCategoryUpdatePayload & { id: number }) => {
  const response = await axiosInstance.patch<RequestResponse<ProductCategory>>(
    `${endpoints.categories}/${id}`,
    payload
  );
  return response.data;
};

export const deleteProductCategory = async (id: number) => {
  const response = await axiosInstance.delete<RequestResponse<null>>(
    `${endpoints.categories}/${id}`
  );
  return response.data;
};

export const updateProductSubcategory = async ({
  id,
  ...payload
}: ProductSubcategoryUpdatePayload & { id: number }) => {
  const response = await axiosInstance.patch<
    RequestResponse<ProductSubcategory>
  >(`${endpoints.subcategories}/${id}`, payload);
  return response.data;
};

export const deleteProductSubcategory = async (id: number) => {
  const response = await axiosInstance.delete<RequestResponse<null>>(
    `${endpoints.subcategories}/${id}`
  );
  return response.data;
};
